// // src/features/Reports/Reports.jsx
import React from 'react';
//import Amortization from './components/Amortization';
import useAmortization from './hooks/useAmortization';
import FilterReport from './components/FilterReport';

const Amortizations = () => {
    const { data, loading, error } = useAmortization();

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error loading reports</div>;

    return (
        <div>
            {/* <Amortization /> */}
            <FilterReport />
        </div>
    );
};

export default Amortizations;

// const Reports = () => {
//     return <div>Reports Page</div>;
// };

// export default Reports;